import { AllowedLanguages, currentLanguage } from 'i18n';

const i18nToL10n: Record<AllowedLanguages, string> = {
  en: 'en-GB',
  de: 'de-DE',
};
export const currentL10n = i18nToL10n[currentLanguage] || 'en-GB';
